import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../services/api.service';
import { LoadingService } from '../services/loading.service';
import { ToastService } from '../services/toast.service';
import { languageSettings } from '../lenguajeDatatable';
import { EmpresaModalComponent } from '../empresa-modal/empresa-modal.component';
import { Empresa } from '../models/empresa.model';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive-bs5';
import 'pdfmake/build/vfs_fonts.js';

@Component({
  selector: 'app-empresa',
  templateUrl: './empresa.component.html',
  styleUrls: ['./empresa.component.css'],
})
export class EmpresaComponent implements OnInit {
  @ViewChild(EmpresaModalComponent)
  empresaModalComponent!: EmpresaModalComponent;
  empresas: Empresa[] = [];
  dataTable: any;
  tablaInicializada: boolean = false;

  constructor(
    private apiSrv: ApiService,
    private loadingSrv: LoadingService,
    private toastSrv: ToastService
  ) {}

  ngOnInit(): void {
    this.obtenerEmpresas();
  }

  obtenerEmpresas(): void {
    this.loadingSrv.setLoading(true);
    this.apiSrv.obtenerEmpresas().subscribe({
      next: (data: Empresa[]) => {
        this.empresas = data;
        setTimeout(() => {
          if (!this.tablaInicializada) {
            this.inicializarTablaEmpresas();
          } else {
            this.actualizarTablaEmpresas();
          }
          this.loadingSrv.setLoading(false);
        }, 0);
      },
      error: (error) => {
        this.toastSrv.mostrarNotificacion(
          'Error al cargar las empresas',
          'error'
        );
        this.loadingSrv.setLoading(false);
      },
    });
  }

  inicializarTablaEmpresas(): void {
    this.dataTable = $('#tablaEmpresas').DataTable({
      data: this.prepararDatosTabla(),
      language: languageSettings,
      columns: [
        { title: 'CUIT' },
        { title: 'Razón Social' },
        { title: 'Acciones', orderable: false },
      ],
      responsive: true,
      dom: 'Bfrtip',
      buttons: [
        {
          extend: 'csv',
          title: 'Empresas - Ribera Salud',
          filename: 'Empresas - Ribera Salud',
          exportOptions: {
            columns: ':not(:last-child)',
          },
        },
        {
          extend: 'excel',
          title: 'Empresas - Ribera Salud',
          filename: 'Empresas - Ribera Salud',
          exportOptions: {
            columns: ':not(:last-child)',
          },
        },
        {
          extend: 'pdf',
          title: 'Empresas - Ribera Salud',
          filename: 'Empresas - Ribera Salud',
          messageTop: 'Listado de empresas registradas en el sistema',
          exportOptions: {
            columns: ':not(:last-child)',
          },
        },
      ],
    });

    this.configurarEventosTabla();
    this.tablaInicializada = true;
  }

  actualizarTablaEmpresas(): void {
    if (this.dataTable) {
      this.dataTable.clear();
      this.dataTable.rows.add(this.prepararDatosTabla());
      this.dataTable.draw(false); // false para mantener la paginación actual
      this.configurarEventosTabla();
    }
  }

  prepararDatosTabla(): any[] {
    return this.empresas.map((empresa) => {
      return [
        empresa.cuit,
        empresa.razonSocial,
        `<div class="d-flex align-items-center">
          <button class="btn-editar btn btn-link p-0 me-3"
            data-cuit="${empresa.cuit}"
            data-razonSocial="${empresa.razonSocial}">
            <i class="fas fa-pencil-alt"></i> Editar
          </button>
          <button class="btn-eliminar btn btn-link text-danger p-0"
            data-cuit="${empresa.cuit}"
            data-razonSocial="${empresa.razonSocial}">
            <i class="fas fa-trash-alt"></i> Eliminar
          </button>
        </div>`,
      ];
    });
  }

  configurarEventosTabla(): void {
    // Desasociar eventos anteriores para evitar duplicados
    $('#tablaEmpresas tbody').off('click', 'button.btn-editar');
    $('#tablaEmpresas tbody').off('click', 'button.btn-eliminar');

    $('#tablaEmpresas tbody').on('click', 'button.btn-editar', (event) => {
      const button = $(event.currentTarget);
      const empresa: Empresa = {
        cuit: Number(button.attr('data-cuit')),
        razonSocial: String(button.attr('data-razonSocial')),
      };
      this.editarEmpresa(empresa);
    });

    $('#tablaEmpresas tbody').on('click', 'button.btn-eliminar', (event) => {
      const button = $(event.currentTarget);
      const empresa: Empresa = {
        cuit: Number(button.attr('data-cuit')),
        razonSocial: String(button.attr('data-razonSocial')),
      };
      this.eliminarEmpresa(empresa);
    });
  }

  recargarTabla(): void {
    this.obtenerEmpresas();
  }

  abrirModoCreacionEmpresa(): void {
    this.eliminarModalBackdrop();
    this.empresaModalComponent.abrirModoCreacionEmpresa();
  }

  editarEmpresa(empresa: Empresa): void {
    this.eliminarModalBackdrop();
    this.empresaModalComponent.abrirModoEdicionEmpresa(empresa);
  }

  eliminarEmpresa(empresa: Empresa): void {
    this.eliminarModalBackdrop();
    this.empresaModalComponent.abrirModoEliminacionEmpresa(empresa);
  }

  eliminarModalBackdrop(): void {
    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach((backdrop) => {
      backdrop.parentNode?.removeChild(backdrop);
    });
  }

  handleEmpresaGuardada(): void {
    this.recargarTabla();
  }

  handleEmpresaActualizada(): void {
    this.recargarTabla();
  }

  handleEmpresaEliminada(): void {
    this.recargarTabla();
  }
}
